<section *ngIf="fileSizeExceeds" class="alert fade show alert-error" role="alertdialog" aria-labelledby="importDialogTitle">
  <div class="row align-items-center">

    <div class="col-1 pr-0" aria-hidden="true"><em class="icon-ico-standard"></em></div>
    <h2 id="importDialogTitle" class="pl-0 col-10 font-bold">{{alertMsg}}</h2>

    <div class="col-1">
      <button type="button" class="close" id="closeBtnif" data-dismiss="alert" aria-label="Close" (click)="onCloseAlert()">
        <em class="material-icons-outlined font-4x" aria-hidden="true">cancel</em>
      </button>
    </div>

  </div>
</section>
<ng-container *ngIf="loaderDisplay">
  <app-preloader [loaderText]="'Uploading File..'" class="w-100 position-fixed preloader-backdrop"></app-preloader>
</ng-container>

<div class="row">
  <div class="col-12">
    <div class="form-group upload-container">
      <label for="uploadFile" id="uploadFileLabel" class="font-bold">{{(label) ? label :'Upload files'}}</label>
      <div onclick="document.getElementById('uploadNewFile').click()">
        <button class="btn btn-clear upload-file" id="upload-fileBtn" role="button">Click here
          <span> to upload files</span>
        </button>
        <p class="form-control-file cursor-pointer" name="casefile" accept="" (change)="onFilesSelection()"
          aria-describedby="projectDocumentsHelp">
          <input #fileInput type="file" id="uploadNewFile" [disabled]="selectedFiles.length>0 && (disabled===true)"
            tabindex="-1">
        </p>
      </div>
      <p id="projectDocumentsHelp" class="form-text text-muted text-right form-text__upload">
        {{(helpText) ? helpText :'Upload any file.'}}</p>
    </div>
    <div class="col-12 file-uploaded">

      <!-- start of loop -->
      <ng-container *ngIf="false">
        <div class="row file-item align-items-center" *ngFor="let file of selectedFiles; let i = index;" role="row">

          <div class="col-3" role="gridcell">
            <div class="col file-type text-center" aria-live="polite" aria-atomic="true">
              <p>{{file.name.split('.').pop().toUpperCase()}}</p>
            </div>
           
          </div>

          <div class="col-7 file-info" aria-live="polite" aria-atomic="true" role="gridcell">
            <p class="font-bold">{{file.name}}</p>

            <ul class="list-inline">
              <li class="list-inline-item">File size: {{ formatBytes(file.size) }}</li>
            </ul>
            <p class="error--msg" *ngIf="messages[i]" role="alert" aria-live="polite" aria-atomic="true"><span class="sr-only">Error</span> {{messages[i]}}
            </p>
          </div>

          <div class="col disabled" role="gridcell">
            <button class="btn btn-clear btn-sm px-1 py-0" id="deleteFileBtn" (click)="deleteFile(i)">
              <span class="material-icons-outlined font-4x">delete</span>
            </button>
          </div>
        </div>
      </ng-container>
      <!-- end of loop -->
    </div>
  </div>

</div>
  